import { __extends, __decorate, __metadata } from 'tslib';
import { Model, Prop, Watch, ProvideReactive, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import __vue_component__ from '../../icons/action/arrow/keyboard/right/IconActionArrowKeyboardRight.vue.js';
import 'reflect-metadata';
import __vue_component__$1 from '../HseIconButton/HseIconButton.vue.js';
import { SidebarSize, SidebarVariant, SidebarContextKey } from './types.js';

/**
 * @figma https://www.figma.com/file/u2kRB4m4a413lPzud3dOah/hse_general_library_workspace?node-id=3498%3A0
 * @storybook /?path=/story/navigation-sidebar--playground
 * @react /src-components-sidebar
 * @reactStorybook /?path=/story/navigation-sidebar--playground
 * @requires ./HseSidebarItem.vue
 * @requires ./HseSidebarCustomItem.vue
 */
var HseSidebar = /** @class */ (function (_super) {
    __extends(HseSidebar, _super);
    function HseSidebar() {
        var _a, _b;
        var _this = _super.apply(this, arguments) || this;
        _this.isOpen = (_b = (_a = _this.open) !== null && _a !== void 0 ? _a : _this.defaultOpen) !== null && _b !== void 0 ? _b : false;
        return _this;
    }
    Object.defineProperty(HseSidebar.prototype, "toggleButtonIcon", {
        get: function () {
            return __vue_component__;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebar.prototype, "isDynamic", {
        get: function () {
            return this.variant === 'dynamic';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebar.prototype, "isStatic", {
        get: function () {
            return this.variant === 'static';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebar.prototype, "needTitle", {
        get: function () {
            return (this.title || this.$slots.title) && this.isStatic;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebar.prototype, "needToggle", {
        get: function () {
            return this.showToggle && this.isDynamic;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSidebar.prototype, "iconButtonClasses", {
        get: function () {
            return {
                icon: 'hse-Sidebar__toggleIcon'
            };
        },
        enumerable: false,
        configurable: true
    });
    HseSidebar.prototype.handleOpenChanged = function (v) {
        if (v !== undefined) {
            this.isOpen = v;
        }
    };
    HseSidebar.prototype.handleDefaultOpen = function (v) {
        if (v !== undefined) {
            this.isOpen = v;
        }
    };
    HseSidebar.prototype.handleToggle = function () {
        var newOpen = !this.isOpen;
        if (this.open === undefined) {
            this.isOpen = newOpen;
        }
        /**
         * Событие изменения видимости
         * @type {boolean}
         */
        this.$emit('toggle', newOpen);
    };
    Object.defineProperty(HseSidebar.prototype, "sidebarContext", {
        get: function () {
            return {
                size: this.size,
                open: this.isOpen,
                variant: this.variant
            };
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Model('toggle'),
        __metadata("design:type", Boolean)
    ], HseSidebar.prototype, "open", void 0);
    __decorate([
        Prop(EnumProp(SidebarSize.wide, SidebarSize)),
        __metadata("design:type", String)
    ], HseSidebar.prototype, "size", void 0);
    __decorate([
        Prop({
            default: 'Свернуть'
        }),
        __metadata("design:type", String)
    ], HseSidebar.prototype, "toggleText", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], HseSidebar.prototype, "defaultOpen", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], HseSidebar.prototype, "showToggle", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], HseSidebar.prototype, "withHeader", void 0);
    __decorate([
        Prop(EnumProp(SidebarVariant.dynamic, SidebarVariant)),
        __metadata("design:type", String)
    ], HseSidebar.prototype, "variant", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseSidebar.prototype, "title", void 0);
    __decorate([
        Prop({
            default: function () { return ({}); }
        }),
        __metadata("design:type", Object)
    ], HseSidebar.prototype, "classes", void 0);
    __decorate([
        Watch('open'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HseSidebar.prototype, "handleOpenChanged", null);
    __decorate([
        Watch('defaultOpen'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HseSidebar.prototype, "handleDefaultOpen", null);
    __decorate([
        ProvideReactive(SidebarContextKey),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], HseSidebar.prototype, "sidebarContext", null);
    HseSidebar = __decorate([
        Component({
            name: 'HseSidebar',
            components: {
                HseIconButton: __vue_component__$1
            },
            inject: []
        })
    ], HseSidebar);
    return HseSidebar;
}(Vue));

export default HseSidebar;
